
// ISW mobile
document.addEventListener("click", function (e) {
  if (e.target.closest('.search-action.desktop\\:hidden button.search-modal__button')) {
    const dispatchSearchEvent = () => {
      window.dispatchEvent(new CustomEvent("bind-search-input"));
    };

    const maxAttempts = 25;
    let attempt = 0;

    const intervalId = setInterval(() => {
      attempt++;
      const initedInput = document.querySelector(
        ".search-input.boost-sd__search-widget-init-input"
      );

      if (initedInput || attempt >= maxAttempts) {
        clearInterval(intervalId);
        initedInput.focus();
      }

      dispatchSearchEvent();
    }, 200);
  };

  const closeButton = document.querySelector('.boost-sd__instant-search-container-mobile .boost-sd__search-bar button[data-group="close-search-form"]');
  const cancelSearchButton = document.querySelector('.button.predictive-search__close-modal-button');

  if (closeButton && cancelSearchButton) {
    if (closeButton.contains(e.target)) {
      cancelSearchButton.click();
    }
  }
});

// ISW desktop
document.addEventListener("DOMContentLoaded", function () {
  console.log("search.js");
  const searchModalHost = document.getElementById("search-modal");

  if (!searchModalHost) return;

  let hasInserted = false;

  const waitForInstantSearch = () => {
    return new Promise((resolve) => {
      const existing = document.getElementById("bc-instant-search");
      if (existing) return resolve(existing);

      const bodyObserver = new MutationObserver((mutations, observer) => {
        const found = document.getElementById("bc-instant-search");
        if (found) {
          observer.disconnect();
          resolve(found);
        }
      });

      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  };

  const waitForPredictiveSearch = () => {
    return new Promise((resolve) => {
      const dialog = searchModalHost.querySelector("dialog, [data-ref='dialog']");
      if (!dialog) return;

      const existing = dialog.querySelector("predictive-search-component");
      if (existing) return resolve(existing);

      const dialogObserver = new MutationObserver((mutations, observer) => {
        const found = dialog.querySelector("predictive-search-component");
        if (found) {
          observer.disconnect();
          resolve(found);
        }
      });

      dialogObserver.observe(dialog, {
        childList: true,
        subtree: true,
      });
    });
  };

  const updateDialogHeight = () => {
    const dialog = searchModalHost.querySelector("dialog, [data-ref='dialog']");
    const isw = document.getElementById("bc-instant-search");

    if (!dialog || !isw) return;

    // Calculate the new total height
    const dialogRect = dialog.getBoundingClientRect();
    const iswRect = isw.getBoundingClientRect();

    // Increase dialog height to accommodate ISW
    const totalHeight = iswRect.height;

    dialog.style.height = `${totalHeight}px`;
    dialog.style.overflow = "visible"; // so that ISW is not cut off
  };

  const modalObserver = new MutationObserver(async () => {
    const dialog = searchModalHost.querySelector("dialog, [data-ref='dialog']");
    const isOpen =
      dialog?.hasAttribute("open") &&
      getComputedStyle(dialog).display !== "none";

    if (isOpen && !hasInserted) {
      console.log(":mag: Search modal is open, waiting for predictive-search and ISW...");

      const [predictive, bcSearch] = await Promise.all([
        waitForPredictiveSearch(),
        waitForInstantSearch(),
      ]);

      if (predictive && bcSearch && !hasInserted) {
        predictive.insertAdjacentElement("afterend", bcSearch);
        console.log(":white_check_mark: Inserted #bc-instant-search into search modal.");
        hasInserted = true;

        // Update dialog height after one frame
        requestAnimationFrame(() => {
          updateDialogHeight();
        });
      }
    }
  });

  modalObserver.observe(searchModalHost, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["open"],
  });
});